import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '../../core/services/toast.service';

@Component({
  selector: 'tc-toast',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (toast.message(); as m) {
      <div class="toast" role="status">{{ m }}</div>
    }
  `,
  styles: `
    .toast {
      position: fixed;
      z-index: 60;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      max-width: calc(100vw - 32px);
      background: var(--text-1);
      color: #fff;
      padding: 10px 16px;
      border-radius: 8px;
      font-size: 13px;
      box-shadow: 0 8px 24px rgba(18, 33, 31, 0.25);
    }
  `,
})
export class Toast {
  protected readonly toast = inject(ToastService);
}
